import ComponentProtected from 'src/components/blocks/ComponentRoleProtected/ComponentRoleProtected';

export default ComponentProtected;
